export type BrowserDateTimeValue = string | number | Date | null | undefined;

function parseCalendarDate(value: string) {
  const match = /^(\d{4})-(\d{2})-(\d{2})$/.exec(value);
  if (!match) return null;
  const year = Number(match[1]);
  const month = Number(match[2]);
  const day = Number(match[3]);
  const date = new Date(year, month - 1, day);
  return date.getFullYear() === year &&
    date.getMonth() === month - 1 &&
    date.getDate() === day
    ? date
    : null;
}

function toDisplayDate(
  value: BrowserDateTimeValue,
  preserveCalendarDate: boolean
): Date | null {
  if (value === null || value === undefined || value === '') return null;
  if (value instanceof Date) {
    return Number.isNaN(value.getTime()) ? null : value;
  }
  if (typeof value === 'string' && preserveCalendarDate) {
    const calendarDate = parseCalendarDate(value);
    if (calendarDate) return calendarDate;
  }
  const date = new Date(value);
  return Number.isNaN(date.getTime()) ? null : date;
}

export function formatBrowserDate(
  value: BrowserDateTimeValue,
  fallback = '-'
): string {
  const date = toDisplayDate(value, true);
  if (!date) return fallback;
  return date.toLocaleDateString();
}

export function formatBrowserDateTime(
  value: BrowserDateTimeValue,
  fallback = '-'
): string {
  const date = toDisplayDate(value, false);
  if (!date) return fallback;
  return date.toLocaleString();
}

export function formatBrowserTime(
  value: BrowserDateTimeValue,
  fallback = '-'
): string {
  const date = toDisplayDate(value, false);
  if (!date) return fallback;
  return date.toLocaleTimeString();
}

export function formatBrowserMonthDay(
  value: BrowserDateTimeValue,
  fallback = '-'
): string {
  const date = toDisplayDate(value, true);
  if (!date) return fallback;
  return new Intl.DateTimeFormat(undefined, {
    month: 'numeric',
    day: 'numeric',
  }).format(date);
}

export function formatBrowserMonthYear(
  value: BrowserDateTimeValue,
  fallback = '-'
): string {
  const date = toDisplayDate(value, true);
  if (!date) return fallback;
  return new Intl.DateTimeFormat(undefined, {
    year: 'numeric',
    month: 'numeric',
  }).format(date);
}
